// extracted by mini-css-extract-plugin
module.exports = {"tagList":"tagList__1WVAo","green":"green__1xva2","tag":"tag__1M8t9","small":"small__1ncO2"};